import React from "react";
import { FaWindowClose } from "react-icons/fa";
import { Card, CardBody } from "reactstrap";

export default function ViewForm({ Modalclose, modalData }) {
  if (!modalData) {
    return null; // or return some default content if modalData is null or undefined
  }
  return (
    <>
      <div className="modal-wrapper"></div>
      <div className="modal-container">
        <div className="modal-head">
          <h1>Glossary DETAILS</h1>
          <div className="close-icon">
            <FaWindowClose onClick={Modalclose} />
          </div>
        </div>
        <div className="modal-body">
          <Card>
            <CardBody>
              <section className="view-blog view-sec">
                <div className="container">
                  <div className="mt-3 view-text">
                    <label className="heading">Title</label>
                    <p>{modalData.title}</p>
                    <label className="heading">Definition</label>
                    <p>{modalData.shortdescription}</p>
                    {modalData.customurlflag && (
                      <div className="email-show">
                        <label className="heading">Custom Url</label>
                        <p>{modalData.customurl}</p>
                      </div>
                    )}
                    {modalData.descriptionflag && (
                      <div className="email-show">
                        <label className="heading">Description</label>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: modalData.description || "",
                          }}
                        />
                      </div>
                    )}
                    <label className="heading">Status</label>
                    <div className="status-details">
                      <span
                        className={`status ${
                          modalData.status ? "active" : "inactive"
                        }`}
                      >
                        {modalData.status ? "active" : "inactive"}
                      </span>
                    </div>
                  </div>
                </div>
              </section>
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
}
